<style scoped>
.box-card label {
    color: #606266;
    font-weight: normal;
    line-height: 2;
}
</style>

<template>
    <div class="app-container clearfix" v-loading="loading">
        <div class="right-20" style="float: left; width: 210px">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="ptitle">科目类别</span>
                </div>
                <label class="font-14">请选择品牌</label>
                <el-select
                    v-model="brandValue"
                    placeholder="当前品牌:"
                    size="mini"
                    class="selectaccount width100 bottom-15"
                    @change="chooseBrand"
                >
                    <el-option
                        v-for="item in brandListFilter"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <div v-show="storeShow">
                    <label class="font-14">请选择门店</label>
                    <el-select
                        filterable
                        v-model="storeValue"
                        placeholder="当前门店:"
                        size="mini"
                        class="selectaccount width100 bottom-15"
                        @change="chooseStore"
                    >
                        <el-option
                            v-for="item in storeListFilter"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div>
                <el-tree
                    ref="tree"
                    :data="subjectTypeList"
                    :props="defaultProps"
                    default-expand-all
                    :expand-on-click-node="false"
                    class="filter-tree"
                    :highlight-current="true"
                    @node-click="handleNodeClick"
                >
                    <span class="custom-tree-node" slot-scope="{ node }">
                        <span>{{ node.label }}</span>
                    </span>
                </el-tree>
            </el-card>
        </div>
        <div class="contentMode">
            <subjectDetail ref="subjectDetail"></subjectDetail>
        </div>
    </div>
</template>

<script>
import subjectDetail from '@/views/voucherAdmin/subjectDetail.vue'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import SubjectService from '../../services/voucher/SubjectService'
export default {
    name: 'subject',
    components: {
        subjectDetail: subjectDetail
    },
    data() {
        return {
            loading: false,
            accountConfInfoList: [],
            accountConfInfoValue: '',
            currentBrandInfo: null,
            brandList: [],
            brandListFilter: [],
            brandValue: '',
            storeList: [],
            storeListFilter: [],
            storeValue: '',
            isMultiOrg: false,
            storeShow: false,
            defaultProps: {},
            subjectTypeList: [
                {
                    label: '科目类别',
                    id: '0',
                    children: []
                }
            ],
            storeListBySameBrandId: [] // 和选中门店 同一品牌的其他门店
        }
    },
    mounted() {
        //this.initAccountConfInfoList();
        this.initAccountBrandStore()
    },
    methods: {
        initAccountBrandStore() {
            const _this = this
            _this.loading = true
            SubjectService.getAccountBrandStoreForSelect()
                .then((r) => {
                    _this.accountConfInfoList = r.accounts
                    //_this.brandList = r.brands;
                    _this.brandListFilter = r.brands
                    _this.storeList = r.stores
                    if (_this.accountConfInfoList.length > 0) {
                        _this.accountConfInfoValue =
                            _this.accountConfInfoList[0].id
                        _this.isMultiOrg =
                            _this.accountConfInfoList[0].isMultiOrg
                        _this.chooseAccount()
                        _this.loading = false
                    } else {
                        // _this.$notify({
                        //     title: "错误",
                        //     message: "品牌对应的账套已过期",
                        //     type: "error",
                        //     position: "bottom-right",
                        // });
                        _this.loading = false
                    }
                })
                .catch(function (error) {
                    _this.loading = false
                })
        },
        chooseAccount() {
            this.clearDetail()
            if (this.brandListFilter.length > 0) {
                this.brandValue = this.brandListFilter[0].id
                this.accountConfInfoValue = this.brandListFilter[0].accountID
                this.isMultiOrg = this.brandListFilter[0].isMultiOrg
                this.chooseBrand()
            }
        },
        chooseBrand() {
            this.clearDetail()
            this.currentBrandInfo = this.brandListFilter.filter(
                (x) => x.id == this.brandValue
            )[0]
            this.isMultiOrg = this.currentBrandInfo.isMultiOrg
            if (this.isMultiOrg) {
                this.storeListFilter = this.storeList.filter(
                    (x) => x.brandID == this.brandValue
                )
                if (this.storeListFilter.length > 0) {
                    this.storeValue = this.storeListFilter[0].id
                    this.accountConfInfoValue =
                        this.storeListFilter[0].accountID
                    this.chooseStore()
                }
                this.storeShow = true
            } else {
                this.storeShow = false
                this.storeValue = null
                this.accountConfInfoValue = this.currentBrandInfo.accountID
                this.initSubjectTypeList()
            }
        },
        chooseStore() {
            this.clearDetail()
            this.storeListBySameBrandId = []
            this.storeListFilter.forEach((s) => {
                if (s.brandID == this.brandValue && s.id != this.storeValue) {
                    this.storeListBySameBrandId.push(s)
                }
                if (s.id == this.storeValue) {
                    this.accountConfInfoValue = s.accountID
                }
            })
            this.initSubjectTypeList()
        },
        initSubjectTypeList() {
            const _this = this
            SubjectService.getSubjectTypesForTree({
                Filter: this.accountConfInfoValue,
                BrandID: this.brandValue
            }).then((r) => {
                if (r.length > 0) {
                    r.forEach((item) => {
                        item.id = item.subjectTypeId
                        item.label = item.subjectTypeName
                    })
                }
                _this.subjectTypeList[0].children = r
            })
        },

        handleNodeClick(node, data, value) {
            if (node.id != 0) {
                this.$refs.subjectDetail.initData(
                    node.id,
                    node.label,
                    this.accountConfInfoValue,
                    this.brandValue,
                    node.moduleMark,
                    this.storeValue,
                    this.isMultiOrg,
                    this.storeListBySameBrandId
                )
            }
        },

        clearDetail() {
            this.$refs.subjectDetail.clearDetail()
        }
    }
}
</script>

<style scoped="scoped">
.el-card {
    height: calc(100vh - 114px - 40px) !important;
}
.contentMode {
    width: calc(100% - 230px);
}
</style>
